export const millisInADay = 86400000;
